<template>
  <b-row>
  
          <b-col  cols="12" xl="6">
        <br> <transition name="slide">
     
       <b-card style="width: 40rem;">
         <div slot="header" v-if="$route.params.pageid === '6'"><h4>Slip Ring</h4></div>
            <div slot="header" v-else><h4>Rotating Unions</h4></div>
   
          <div slot="header" v-if="$route.params.pageid === '1'"><h3>Water and Hot Oil 250F</h3></div>
         <div slot="header" v-if="$route.params.pageid === '2'"><h3>Water and Hot Oil 450F</h3></div>
        <div slot="header" v-if="$route.params.pageid === '3'"><h3>Air and Hydraulic</h3></div>
        <div slot="header" v-if="$route.params.pageid === '4'"><h3>Coolant</h3></div>
        <div slot="header" v-if="$route.params.pageid === '5'"><h3>Special Application</h3></div>
     
     
         <b-table v-if="$route.params.pageid === '1'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items1" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>
            <b-table v-if="$route.params.pageid === '2'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items2" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>
              <b-table v-if="$route.params.pageid === '3'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items3" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>
                  <b-table v-if="$route.params.pageid === '4'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items4" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>
                <b-table v-if="$route.params.pageid === '5'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items5" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>
      <div>

 


<div v-if="$route.params.pageid === '6'">
           <b-table v-if="$route.params.pageid === '6'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items6" :fields="fields2" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>

</div>
<div v-if="$route.params.pageid === '7'">
           <b-table v-if="$route.params.pageid === '7'" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items7" :fields="fields3" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
         
          <template slot="size" slot-scope="data">
            <strong>{{data.item.size}}</strong>
          </template>
          <template slot="detail" slot-scope="data">
            <b-badge :variant="getBadge(data.item.detail)">{{data.item.detail}}</b-badge>
          </template>
        </b-table>

</div>
</div>
<!--       <div class="card mb-3">
  <div class="row no-gutters">
    <div class="col-md-4">
      <img src="img/slide1.jpg" class="card-img" alt="">
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">Deublin Rotating Union</h5>
        <p class="card-text">Rotating Unions (also known as rotary swivels, rotary couplings, rotary joints) are precision mechanical devices used to transfer fluid from a stationary source, such as a supply pipe, into a rotating piece of machinery.


Rotating Unions are used in numerous manufacturing processes to cool, heat, or transfer fluid (pneumatic or hydraulic) power.
 
Deublin offers one (single flow) passage unions, two (dual flow) passage unions, three (triple) passage and four passage unions. Rotary Unions allow the feed through of water, glycol, air, hydraulic, coolant, MQL, hot oil, steam, vacuum and a variety of other media. Rotary Unions (Joints) can be configured for installation at the end of a shaft or around-the-shaft.</p>
        <p class="card-text"><small class="text-muted"></small></p>
      </div>
    </div>
  </div>
</div>
    -->
    
        
     <!--   <nav>
          <b-pagination size="sm" :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
        -->
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
console.log("ter");
  
import productsData1 from './ProductsData1'
import productsData2 from './ProductsData2'
import productsData3 from './ProductsData3'
import productsData4 from './ProductsData4'
import productsData5 from './ProductsData5'
import productsData6 from './ProductsData6'
import productsData7 from './ProductsData7'
export default {
  name: 'Products',
  props: {
    caption: {
      type: String,
      default: 'Water & Hot Oil 250F'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
 
  data: () => {
 
   
    return {
       
 
   
          items1: productsData1.filter((product) => product.id < 42),
      items2: productsData2.filter((product) => product.id < 42),
     items3: productsData3.filter((product) => product.id < 42),
     items4: productsData4.filter((product) => product.id < 42),
     items5: productsData5.filter((product) => product.id < 42),
    items6: productsData6.filter((product) => product.id < 42),
   items7: productsData7.filter((product) => product.id < 42),
   
      fields: [
       // {key: 'id'},
       {key: 'size'},
        {key: 'series'},
        {key: 'description'},
        {key: 'passages'},
       {key: 'detail'}
      ],
         fields2: [
       // {key: 'id'},
         {key: 'model'},
        {key: 'industry'},
        {key: 'application'},
        {key: 'detail'}
      ],
       fields3: [
       // {key: 'id'},
         {key: 'name'},
        {key: 'type'},
        {key: 'series'},
        {key: 'detail'}
      ],
      currentPage: 1,
      perPage:20,
      totalRows: 0
       
      
    
    }
  },
  computed: {
    
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    productLink (id,pageid) {
      return `details/${pageid.toString()}/${id.toString()}`
    },
    rowClicked (item) {
      const productLink = this.productLink(item.id,this.$route.params.pageid)
      this.$router.push({path: productLink})
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
